// =============================================================================
// src/features/analytics/analytics-digest-markup.ts - aba "Resumo de IA".
// Desde 2026-07-28 exibe as EDICOES VIVAS dos Cards de Inteligencia Tatica
// (banco social_listening -> Hasura sl_serving_v_card_edition -> parser TS),
// com navegacao entre dias FORA do host re-renderizavel. Fallback: o port
// estatico de 25/07 (padrao override ?? mock), identico ao comportamento
// anterior — com a tag "demonstracao" quando o dashboard esta live e as
// edicoes nao (honestidade visual, precedente analytics-demo-tag).
// Historia: em 2026-07-27 a aba era o port ESTATICO ("faca em resumo de IA e
// habilite o menu"); o requisito virou diario automatico e o estatico virou
// fallback.
// =============================================================================

import { debugLiveIntegration } from '../../data/live-debug';
import { analyticsDemoTagMarkup } from './analytics-demo-tag';
import {
  analyticsInsightActiveEditionRef,
  analyticsInsightsLiveActive,
  cachedAnalyticsInsightParsedDoc,
} from './analytics-insights-live-store';
import {
  buildAnalyticsInsightGenericDocMarkup,
  buildAnalyticsInsightsViewMarkup,
} from './analytics-insights-markup';
import { buildAnalyticsInsightNavMarkup } from './analytics-insights-nav-markup';

/** Renderiza a aba Resumo de IA: nav de edicoes + documento ativo. */
export function buildAnalyticsDigestViewMarkup(): string {
  return `<section class="u-analytics-module" data-analytics-module-view="digest" aria-labelledby="analyticsDigestTitle" hidden>
    ${buildAnalyticsInsightNavMarkup()}
    <div class="u-analytics-insight-doc" id="analyticsInsightDocHost">${analyticsInsightActiveDocMarkup()}</div>
  </section>`;
}

/** Documento da edicao ATIVA (cache do parse ?? estatico). Cinturao final:
 * exceção de render NUNCA escapa p/ mountRouteLayer/click — cai no estatico. */
export function analyticsInsightActiveDocMarkup(): string {
  try {
    const activeRef = analyticsInsightsLiveActive() ? analyticsInsightActiveEditionRef() : null;
    const cachedDoc = activeRef === null ? null : cachedAnalyticsInsightParsedDoc(activeRef.editionDate);
    if (cachedDoc?.outcome === 'cards') return buildAnalyticsInsightsViewMarkup(cachedDoc.editionDoc);
    if (cachedDoc?.outcome === 'generic') return buildAnalyticsInsightGenericDocMarkup(cachedDoc.genericSections);
  } catch (renderError) {
    debugLiveIntegration('analytics-insights', 'render_fallback_static', {
      /* v8 ignore next -- o render interno so lanca Error; String(...) e defensivo p/ throw exotico */
      error: renderError instanceof Error ? renderError.message : String(renderError),
    });
  }
  return analyticsInsightStaticDocMarkup();
}

/** Fallback estatico; a demo tag so aparece com dashboard live + digest static
 * (analyticsDemoTagMarkup ja devolve '' quando tudo e static). */
function analyticsInsightStaticDocMarkup(): string {
  const demoTag = analyticsDemoTagMarkup();
  const demoRowMarkup = demoTag === '' ? '' : `<div class="u-analytics-insight-demo-row">${demoTag}</div>`;
  return `${demoRowMarkup}${buildAnalyticsInsightsViewMarkup()}`;
}
